var CONFETTI_BACKGROUND_SIZE = {
  xs: {
    width: 375,
    height: 590
  },
  md: {
    width: 768,
    height: 536
  },
  lg: {
    width: 1024,
    height: 714
  },
  xl: {
    width: 1440,
    height: 370
  }
};
export default CONFETTI_BACKGROUND_SIZE;